import { render, staticRenderFns } from "./OtherType.vue?vue&type=template&id=3e0fc174&scoped=true"
import script from "./OtherType.vue?vue&type=script&lang=js"
export * from "./OtherType.vue?vue&type=script&lang=js"
import style0 from "./OtherType.vue?vue&type=style&index=0&id=3e0fc174&prod&lang=less"
import style1 from "./OtherType.vue?vue&type=style&index=1&id=3e0fc174&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0fc174",
  null
  
)

export default component.exports